export default __webpack_public_path__ + "static/spottune-16c2d128d65db5f57df82899b1653bb4.svg";